import React from 'react';
import NoteNodeForm from 'routes/surface/components/node-modal-form/components/note-node-modal/components/note-node-form';
import useSaveSurfaceNoteNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-note-node';
import useSurfaceNodeInitialValuesFromServer from 'routes/surface/components/node-modal-form/hooks/use-surface-node-initial-values-from-server';
import { withModal } from 'hoc';
import { flow, omit, set } from 'lodash/fp';
import { ModalContext } from 'hoc/with-modal';
import { NodeModalInput } from 'types';
import { SurfaceNoteNode } from 'graphql/types';

export interface NoteNodeModalContentProps {
  data: NodeModalInput<SurfaceNoteNode>;
  modal: ModalContext;
  deleteNode: Function;
}

const defaultProps = {};

function NoteNodeModalContent(props: NoteNodeModalContentProps) {
  const {
    initialValues: data,
    isLoading,
  } = useSurfaceNodeInitialValuesFromServer(props.data);

  const saveNoteNode = useSaveSurfaceNoteNode();

  function onSubmit(input) {
    return saveNoteNode({ variables: { input } });
  }

  const initialValues = flow(
    set('slateData', { data: data.slateData, text: data.text }),
    omit(['text']),
  )(data);

  if (isLoading) {
    return null;
  }

  return (
    <NoteNodeForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      closeForm={props.modal.hide}
    />
  );
}

const NoteNodeModal = withModal(NoteNodeModalContent);

NoteNodeModal.defaultProps = defaultProps;

export default NoteNodeModal;
